import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useId, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin, changeLogId } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

import { changeNum, formatDateTime } from '../common/function'

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function LogGold() {
    let dark = useSelector((state) => { return state.Darkmode.value });
    let log_id = useSelector((state) => { return state.log_id.value });

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID")
    const [page, setPage] = useState(1)
    const [totalpage, setTotalPage] = useState(1)

    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const statusRef = useRef(null)

    const [data, setData] = useState([])
    const [dataList, setDataList] = useState([])
    const [statusSelect, setStatusSelect] = useState(false)
    const [statusPosition, setStatusPosition] = useState("")

    const [checked, setChecked] = useState(true)
    const [checked1, setChecked1] = useState(true)
    const [checked2, setChecked2] = useState(true)

    const [dateBtn, setDateBtn] = useState(0);
    const [selectedDate, setSelectedDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d;
    });
    const [selectedDate1, setSelectedDate1] = useState(() => new Date());

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSubmitSearch()
        }
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""))
        }, 100)
    }, [])

    useEffect(() => {
        UpgradeData()
    }, [page, reload, selectedDate, selectedDate1])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/log/gold', {
            params: {
                page: page,
                pageSize: 20,
                startDate: formatDateTime(selectedDate),
                endDate: formatDateTime(selectedDate1),
                userId: search
            }
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp)
            if (tmp?.code == 1000) {
                setData(tmp?.data?.log ?? [])
                setPage(tmp?.data?.pagination.currentPage ?? 0)
                setTotalPage(tmp?.data?.pagination?.totalRecords ?? 0)
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    useEffect(() => {
        if (data && data.length > 0) {
            let filter1 = [];

            data.map(function (a, i) {
                if (checked & a.his_type == '0') filter1.push(a)
                if (checked1 & a.his_type == '1') filter1.push(a)
                if (checked2 & a.his_type == '2') filter1.push(a)
            })

            setDataList(filter1);
        } else {
            setDataList([]);
        }
    }, [data, checked, checked1, checked2])

    const handleCheckCoordinates = () => {
        if (statusRef.current) {
            const rect = statusRef.current.getBoundingClientRect();

            setStatusPosition({ "top": rect.top + 24, "left": Math.max(580, rect.left - 10) })
        }
    };

    let filterData = dataList

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                {
                    statusSelect
                        ? <>
                            <div className='modal' onClick={(e) => { e.stopPropagation(); setStatusSelect(false) }}></div>
                            <div className={`member-status-select-box ${darkname}`} style={{ top: statusPosition.top, left: statusPosition.left }}>
                                <div className='member-status-box'>
                                    <span>누적</span>
                                    <span className={checked ? 'regist-box-left-form-3-span1 checked' : 'regist-box-left-form-3-span1'} onClick={() => setChecked(checked => !checked)}></span>
                                </div>
                                <div className='member-status-box'>
                                    <span>소비</span>
                                    <span className={checked1 ? 'regist-box-left-form-3-span1 checked' : 'regist-box-left-form-3-span1'} onClick={() => setChecked1(checked => !checked)}></span>
                                </div>
                                <div className='member-status-box'>
                                    <span>리워드</span>
                                    <span className={checked2 ? 'regist-box-left-form-3-span1 checked' : 'regist-box-left-form-3-span1'} onClick={() => setChecked2(checked => !checked)}></span>
                                </div>
                            </div>
                        </>
                        :
                        ""
                }
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ?
                                    <FontAwesomeIcon icon={faSortUp} />
                                    :
                                    <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue(`ID`); setSelect(true) }}>ID</div>
                                        </div>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input value={search} onChange={onChangeSearch} placeholder='Search' onKeyDown={handleKeyPress} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0
                                    ?
                                    <FontAwesomeIcon icon={faCircleXmark} className='member-1-search-ico-2' onClick={() => setSearch("")} />
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => onSubmitSearch()}>Search</div>

                    {/* 날짜+시간 선택 버튼 */}
                    <div className={`modal-3-1-left ${darkname}`} style={{ marginLeft: "10px" }}>
                        {/* Today 버튼 */}
                        <div
                            className={dateBtn === 1 ? "modal-3-1-left-1 on" : "modal-3-1-left-1"}
                            onClick={() => {
                                setDateBtn(1);

                                // 오늘 00시
                                const todayStart = new Date();
                                todayStart.setHours(0, 0, 0, 0);

                                // 지금 시각
                                const now = new Date();

                                setSelectedDate(todayStart);
                                setSelectedDate1(now);
                            }}
                        >
                            Today
                        </div>

                        {/* 직접 날짜+시간 선택 */}
                        <div
                            className={dateBtn === 5 ? "modal-3-1-left-1 on flex" : "modal-3-1-left-1 flex"}
                            onClick={() => setDateBtn(5)}
                            style={{ gap: "5px" }}
                        >
                            {/* 시작일 + 시간 */}
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="시작일/시간 선택"
                                shouldCloseOnSelect
                                // minDate={new Date("2000-01-01")}
                                maxDate={selectedDate1}
                            />
                            <div>~</div>
                            {/* 종료일 + 시간 */}
                            <DatePicker
                                selected={selectedDate1}
                                onChange={(date) => setSelectedDate1(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="종료일/시간 선택"
                                shouldCloseOnSelect
                                minDate={selectedDate}
                            // maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>
                <div className={`member-2 ${darkname}`} style={{ width: "1100px" }}>
                    <div className={`table-head ${darkname}`}>
                        {/* <div className={name1 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => { { setName1(name1 => name1 === 1 ? 2 : 1); setName2(0); setName3(0) } }}
                            style={{ width: "10%", minWidth: "100px" }}>
                            <span>no.</span>
                            <span style={{paddingTop:"1px"}}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name1 === 2 ? "fill-color" : ""}`} d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name1 === 1 ? "fill-color" : ""}`} d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                </span>
                            </span>
                        </div> */}

                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>로그 날짜</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>로그 유형</div>

                        {/* <div style={{ width: "10%", minWidth: "100px", cursor: 'pointer' }} ref={statusRef}
                            onClick={(e) => { e.stopPropagation(); handleCheckCoordinates(); setStatusSelect(true) }}>
                            로그 유형 <FontAwesomeIcon icon={faSquareCaretDown} style={{ paddingLeft: "3px" }} />
                        </div> */}

                        <div style={{ width: "10%", minWidth: "100px" }}>변동량</div>
                        <div style={{ width: "10%", minWidth: "130px" }}>변동 전 수량</div>
                        <div style={{ width: "10%", minWidth: "130px" }}>변동 후 수량</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>부연설명</div>
                        <div>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                filterData.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            filterData.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={totalpage} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, }) {
    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.id}</div>
                <div className='td' style={{ width: "10%", minWidth: "150px" }}>{item.his_date}</div>
                <div className='right td' style={{ width: "10%", minWidth: "120px" }}>{item.user_id}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.his_type === "0" ? '누적' : item.his_type === "1" ? "소비" : item.his_type === "2" ? "리워드" : ""}</div>
                <div className='right td' style={{ width: "10%", minWidth: "100px" }}>{changeNum(item.his_amount)}</div>
                <div className='right td' style={{ width: "10%", minWidth: "130px" }}>{changeNum(item.his_before === 0 ? item?.his_balance ?? 0 : item?.his_before ?? 0)}</div>
                <div className='right td' style={{ width: "10%", minWidth: "130px" }}>{changeNum(item.his_after === 0 ? item?.his_balance ?? 0 : item?.his_after ?? 0)}</div>
                <div className='left td' style={{ width: "10%", minWidth: "150px" }}>{item.his_desc}</div>
                <div className='td'>-</div>
            </div>
        </>
    )
}

export default LogGold;